import { supabase } from "@/integrations/supabase/client";

export interface ActiveInstitutionalEnrollment {
  cohort_id: string;
  school_id: string;
  start_at: string;
  end_at: string;
  name: string;
  min_weekly_levels: number | null;
  enrolled_at: string;
  created_by_institution: boolean | null;
  cohort_is_active: boolean;
  cohort_status: string | null;
}

export async function fetchMyActiveInstitutionalEnrollment(): Promise<ActiveInstitutionalEnrollment | null> {
  const { data, error } = await supabase.rpc("get_my_active_institutional_enrollment" as any);

  if (error) {
    throw error;
  }

  const rows = Array.isArray(data) ? (data as ActiveInstitutionalEnrollment[]) : [];
  return rows[0] ?? null;
}

export function hasCohortAccessFromEnrollment(
  enrollment: ActiveInstitutionalEnrollment | null,
  now: Date = new Date()
): boolean {
  if (!enrollment || !enrollment.cohort_is_active) return false;
  return new Date(enrollment.end_at) >= now;
}

export function deriveProgramWindowFromEnrollment(
  enrollment: ActiveInstitutionalEnrollment | null,
  now: Date = new Date()
) {
  if (!enrollment || !enrollment.cohort_is_active) {
    return {
      isProgramNotStarted: false,
      cohortEnded: false,
      isProgramActive: false,
    };
  }

  const startAt = new Date(enrollment.start_at);
  const endAt = new Date(enrollment.end_at);
  const isProgramNotStarted = startAt > now;
  const cohortEnded = endAt < now;

  return {
    isProgramNotStarted,
    cohortEnded,
    isProgramActive: !isProgramNotStarted && !cohortEnded,
  };
}